import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import {CarrierService} from 'app/services/carrier.service';
import {CurrencyFormat} from 'app/pipes/currencyFormat.pipe';
import {PopupService} from 'app/services/shared/popup.service';
import {AuthWebService} from 'app/services/authweb.service';
import {accounting} from 'accounting';
import {PermitService} from 'app/services/permit.service';
import {ApplicationService} from 'app/services/application.service';
import {StatusService} from 'app/services/status.service';
import {RouteService} from 'app/services/route.service';
import {UtilityServiceService} from 'app/services/utility-service.service';
import {environment} from 'environments/environment';
import {ToastrService} from 'ngx-toastr';
import {StorageService} from 'app/services/storage.service';
import {VehicleTypeService} from 'app/services/vehicle-type.service';
import {ConfirmDialogService} from 'app/services/shared/confirm-dialog/confirm-dialog.service';
import {data} from 'jquery';
import {ToastNotificationService} from 'app/shared/toast-notification/toast-notification.service';
import {FilterService} from '../shared/filter/filter.service';
import {take} from 'rxjs/operators';

declare var $;

@Component({
    selector: 'app-permit-list-application',
    templateUrl: './permit-list-application.component.html',
    styleUrls: ['./permit-list-application.component.css'],
    providers: [CurrencyFormat, RouteService]
})
export class PermitListApplicationComponent implements OnInit {
    dataCntrl: any = {carrierID: -1, carrier: {}, applications: [], applicationtype: {}, vehicles: [], applicationId: -1};
    pageSize: number = 10;
    pageSizeMax: number = 2147483647; // C# Int32.MaxValue
    pageNumber: number = 1;
    Count: number = 0;
    pageload: boolean;
    gridload: boolean = false;
    direction = false;
    user
    acc: any = {link_person: '', status: ''};
    application: any;
    status: any = '';
    statuses: any = [];
    routes: any = [];
    vehTypes: any = {};
    statusesFilter: any = [];
    selectedItems: any = [];
    dropdownSettings: any = {};
    ShowFilter = false;
    keyword: any = {};
    permitNumber: String;

    carrierNumber: string;
    routeName: string;
    flags = {flagAN: 1, flagNM: 1, flagLU: 1, flagCT: 1, flagAP: 1, flagPT: 1, flagST: 1, flagDS: 1};
    ranks = {flagAN: 1, flagNM: 2, flagLU: 3, flagCT: 4, flagAP: 5, flagPT: 6, flagST: 7, flagDS: 8};
    sortLabels = {
        flagAN: 'AccountNumber',
        flagNM: 'Name',
        flagLU: 'LeadUser',
        flagCT: 'CarrierType',
        flagAP: 'ApplicationNumber',
        flagPT: 'PermitType',
        flagST: 'Status',
        flagDS: 'DateSubmitted'
    };
    limitSelection = false;
    criteria = 'DateSubmitted';
    rankCtrl: number = 8;
    isDef: boolean = true;
    permits: any = [];
    isEmpty: boolean = false;
    count: number = 0;
    message = 'Loading permits. Please wait...';
    permitObj: any = {permits: [], vehicles: []};
    vehicles: any = [];
    mySearchKey
    PermitStatus10: any = 0;
    appId = 0;
    pdfSrc: any;
    isLoadingImg = false;
    selectedIndex: number;
    loadCompleted: boolean = false;

    permitStatus1: number;    // Saved but not submitted
    permitStatus2: number;    // Submitted
    permitStatus4: number;    // Approved
    permitStatus6: number;    // Quote accepted
    permitStatus7: number;    // Quote & details accepted
    permitStatus8: number;    // Printed
    permitStatus10: number;   // Ready for printing
    permitStatus11: number;   // Expired
    permitStatus12: number;   // Rejeted or Declined
    permitStatus13: number;   // Returned
    permitStatus15: number;   // Cancelled

    selectedPermitData = null;
    isViewPermitHistory: boolean = false;
    regNumber: string = '';
    permitStatus: any =[];

    constructor(private router: Router, private activeRoute: ActivatedRoute,
                private carrierService: CarrierService,
                private permitService: PermitService,
                private statusService: StatusService,
                private applicationService: ApplicationService,
                private routeService: RouteService,
                private vehicleService: VehicleTypeService,
                public utility: UtilityServiceService,
                private filter: FilterService,
                private toaster: ToastrService, private confirmDialogService: ConfirmDialogService,
                private session: StorageService, private toastService: ToastNotificationService,
                public currformat: CurrencyFormat, public showModal: PopupService, private authWebService: AuthWebService) {
        this.user = (this.authWebService.userData) ? this.authWebService.userData.User : null;
    }

    onReset = () => {
        this.selectedItems = [];
        this.permitNumber = null;
        this.routeName = null;
        this.initKeyword();
        this.utility.page = 1;
        this.message = 'Loading  permit applications, please wait...';
        this.getApplications();
    }

    onItemSelect(item: any) {
    }

    onDeSelect(item: any) {
    }

    onSelectAll(items: any) {
    }
    loadStatuses = () => {
        this.statusService.statusesDDL(2).subscribe((result: any) => {
            this.statuses = result.map(row => {
                return {id: row.id, desc: row.desc};
            });
            // this.statuses.sort((a,b) => a.sort_order > b.sort_order ? 1 : -1 &&  a.group_code > b.group_code ? 1 : -1 &&  a.id > b.id ? 1 : -1)
            this.statuses.sort((a, b) => a.sort_order > b.sort_order ? 1 : -1 && a.desc > b.desc ? 1 : -1)
            this.loadAccounts();
        });

    }
    setSearchKeywords = () => {
        this.keyword.CarrierID = this.dataCntrl.carrierID;
        this.keyword.permitNumber = (this.permitNumber) ? this.permitNumber : 'All';
        this.keyword.Statuses = (this.selectedItems) ? this.selectedItems.map(status => {
            return status.id;
        }) : [];
    }
    initKeyword = () => {
        this.keyword = {permitNumber: 'All', Statuses: []};
        this.retrieveDefaultStatuses();
    }
    isSearchable = () => {
        return (this.permitNumber != null || this.regNumber != null || this.permitStatus);
    }
    retrieveDefaultStatuses = () => {
        if (this.authWebService.userData) {
            this.permitStatus2 = +this.authWebService.userData.Configurations.find(config => config.Code == 'PermitStatus2').Value;  // submitted
            this.permitStatus4 = +this.authWebService.userData.Configurations.find(config => config.Code == 'PermitStatus4').Value;  // approved
            this.permitStatus6 = +this.authWebService.userData.Configurations.find(config => config.Code == 'PermitStatus6').Value;  // application and permit fee quote has been accepted
            this.permitStatus8 = +this.authWebService.userData.Configurations.find(config => config.Code == 'PermitStatus8').Value;  // permit has been printed
            this.keyword.Statuses = [this.permitStatus2, 74]; // Submitted, STATUS CODE 74 = Submitted - Compliance
        }
    }

    InitMultiselect() {
        this.dropdownSettings = {
            singleSelection: false,
            idField: 'id',
            textField: 'desc',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            itemsShowLimit: 10,
            allowSearchFilter: this.ShowFilter,
            maxHeight: 210,
            closeDropDownOnSelection: false
        };
    }


    ngOnInit() {

        ////console.log(this.user);
        if (environment.authWebApi.systemData != null && environment.authWebApi.systemData.Configurations != null) {
            this.permitStatus1 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus1').Value;
            this.permitStatus2 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus2').Value;
            this.permitStatus4 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus4').Value;
            this.permitStatus6 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus6').Value;
            this.permitStatus7 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus7').Value;
            this.permitStatus8 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus8').Value;
            this.permitStatus10 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus10').Value;
            this.permitStatus11 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus11').Value;
            this.permitStatus12 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus12').Value;
            this.permitStatus13 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus13').Value;
            this.permitStatus15 = environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitStatus15').Value;
        }
        this.PermitStatus10 = this.authWebService.userData.Configurations.find(p => p.Code == 'PermitStatus10').Value
        if (this.router.url.indexOf('cancel') > 0) {
            this.activeRoute.params.subscribe((params: Params) => {
                    this.dataCntrl.carrierID = params['id'];
                    this.appId = params['appid'];
                }
            );
        }
        if (this.router.url.indexOf('history') > 0) {
            this.activeRoute.params.subscribe((params: Params) => {
                    this.dataCntrl.carrierID = params['carrierid'];
                    this.isViewPermitHistory = true;
                }
            );
        } else {
            this.activeRoute.params.subscribe((params: Params) => {
                    this.dataCntrl.carrierID = params['id'];
                }
            );
        }

        this.utility.changeKey = 0;
        this.getStatus();
        this.getApplications();
        this.getCarrier();
        this.loadAccounts();
        this.initKeyword();
        this.getRoutes();
        this.InitMultiselect();
    }

    copyPermit(id) {
        this.gridload = true;
        this.permitService.copyPermit(id).subscribe((data: any) => {
            this.gridload = false;
            console.log(data);
            let num_of_renewals: any = data.application.permit_type.num_renewals_allowed;

            let renewal_count: any = data.application.permits.find(p => p.id == id).renewal_num;
            if (num_of_renewals == 0 || renewal_count > num_of_renewals) {
                if (num_of_renewals == 0) {
                    this.toastService.error('Permit Renewal is not allowed on this Permit Type', 'Renew Permit');
                } else {
                    this.toastService.error('You have already exceeded the renewal limit on this permit', 'Renew Permit');
                }
                $('#selectControl option[value=\'\']').prop('selected', true);
                return false;
            } else {
                this.renewPermit(data, id);
            }
        })
    }

    renewPermit(data, id) {
        if (data.application.permits[0].renewal_num == null) {
            data.application.permits[0].renewal_num = 1;
        } else {
            data.application.permits[0].renewal_num = parseInt(data.application.permits[0].renewal_num) + 1;
        }
        this.updatePermit(data, id);
    }

    updatePermit(res, id) {

        this.permitService.upadatePermit(res.application.permits.find(p => p.id == id)).subscribe(result => {
            res.application.permit = result;
            res.permit = result;
            this.permitService.RenewPermit(res).subscribe((res1: any) => {
                let url: any = 'carrier/permit/application/renew/' + res1.permit.id + '/' + this.dataCntrl.carrierID + '/' + true;
                this.router.navigate([url]);

            })
        })
    }
 i: number = 0;
    getApplications() {
        console.log("Fired Get Applications", this.i++)
        this.gridload = true;
            this.searchPermit(this.permitNumber, this.permitStatus, this.regNumber);
        // this.carrierService.getCarrierPermits(this.dataCntrl.carrierID, this.pageNumber, this.pageSize, this.appId).subscribe(result => {
        //     this.setApplicationData(result);
        //
        // }, error => {
        //     this.gridload = false;
        //     this.loadCompleted = true;
        //     this.isEmpty = false;
        // });


    }

    onSort() {
        this.direction = !this.direction;
    }

    setApplicationData(data) {
        this.loadCompleted = false;

        //console.log(data);
        //console.log(data)
        data.Items.forEach(element => {
            element.total_fees = this.formatCurrency(element.total_fees);
        });

        let count: any = 0;
        //this.dataCntrl.applications = [];
        let listItems: any = [];
        listItems = data.Items;


        let arrayList: any = [];
        let permitList: any = [];
        listItems.forEach(item => {
            permitList.push(item.permits)
            //.permits = item.permits
            this.vehicles = item.vehicle

            // permitList.push(item.vehicle)
            // permitList = [ ...item.permits, ...item.vehicle];


            //console.log("------------" + JSON.stringify(this.dataCntrl.applications));
        })

        listItems.forEach(currentItem => {
            let permit: any = currentItem;
            this.applicationService.getById(permit.application_id).subscribe(result => {
                let application: any = result;
                //alert(JSON.stringify(application));
                // application.permit.id = permit.id;
                // application.permit.permit_num = permit.permit_num;

                // insert permit status
                let status: any = this.statuses.find(x => x.id == permit.status_id);
                application.status_id = status.id;
                application.status = status.description;

                // retrieve the route description
                // let route: any = this.routes.find(rt => rt.id == application.route_id);
                // //console.log(this.routes);
                // //console.log(route);
                // application.route_desccription = route.description;

                application.registration_number = permit.vehicle_reg_num;

                // if (application.vehicle.length > 0) {
                //   this.getVehicle(application, permit.id);
                // } else {
                //   application.vehicle_type_code = "";
                //   application.vehicle_type = "";
                // }
                // let vehicle: any = application.vehicle.find(x => x.permit_id == permit.id);
                // application.vehicle_type_code = vehicle.code;
                // application.vehicle_type = vehicle.description;

                permit.application = application;
                arrayList.push(Object.assign({}, permit));

            }, error => {
                this.gridload = false;
                permit.application = null;
                arrayList.push(Object.assign({}, permit));

            });
            count++;
        });


        setTimeout(() => {
            this.gridload = false;
            this.Count = data.Count;

            for (let i = arrayList.length - 1; i >= 0; i--) {
                if (arrayList[i].application.status === 'Saved but not Submitted' || arrayList[i].application.status === 'Submitted' || arrayList[i].application.status === 'Cancelled') {
                    arrayList.splice(i, 1);
                }
            }

            this.dataCntrl.permits = arrayList;
            console.log('Permit Data', this.dataCntrl.permits);
            this.loadCompleted = true;

        }, 6000);
    }

    sortByAsc(list) {

        return list.sort((a, b) => {
            var x = a.permit_num + a.permit_issue;
            var y = b.permit_num + b.permit_issue;
            return ((x < y) ? -1 : (x > y) ? 1 : 0);
        });
    }

    getStatus() {
        this.statusService.getAll().subscribe(result => {
            this.statuses = result;
        })
    }

    getRoutes() {
        this.routeService.getAllRoute().subscribe(data => {
            //console.log(data);
            this.routes = data;
        });
    }

    formatCurrency(value) {
        return accounting.formatMoney(value, 'R', 2, ' ', '.');
    }

    getCarrier() {
        this.pageload = true;
        this.carrierService.getById(this.dataCntrl.carrierID).subscribe(result => {
            this.setCarrierData(result);
            //console.log(result)
            this.pageload = false;
        }, error => {
            this.pageload = false;
            //console.log(error);
        });
    }

    setCarrierData(data) {
        if (data.account_balance != 0) {
            data.account_balance = -(parseFloat(data.account_balance));
        }
        data.account_balance = data.account_balance != 0 ? this.currformat.transform(parseFloat(data.account_balance)) : 'R 0.00';
        this.dataCntrl.carrier = data;
    }

    loadAccounts() {
        if (this.user) {
            this.carrierService.listCarrierAccountsByUserId(this.user.Id, 5, 1).subscribe((result: any) => {
                console.log(`result for ${this.dataCntrl.carrierID}`, result)
                if (result) {
                    this.acc = result.data.find(x => x.id == this.dataCntrl.carrierID);
                    if (this.acc?.account_balance != 0 && this.acc) {
                        this.acc.account_balance = -(parseFloat(this.acc.account_balance));
                    }
                }

                //console.log("this.acc " +JSON.stringify( this.acc) );
            }, error => {

            })
        }
    }

    onBack() {
        if (this.utility.isfromCarrier == true) {
            this.utility.isfromCarrier = false;
            this.router.navigateByUrl('/carrier/accounts/VCA');
        } else if (this.isViewPermitHistory) {
            this.router.navigateByUrl('/account/approval');
        } else {
            this.router.navigateByUrl('/carrier/application-permit');
        }

    }

    editApplication(id) {

        this.router.navigateByUrl(`/carrier/permit/edit/${id}`);

    }

    viewApplication(id) {
        this.router.navigateByUrl(`/carrier/permit/edit/${id}/false`); //false to just the application
    }

    onPage(page) {
        this.pageNumber = page
        this.getApplications();
        return page;
    }

    pageSizeName(value) {
        if (value === this.pageSizeMax) {
            return 'All';
        }
        return value;
    }

    pageSizes() {
        return [5, 10, 25, 50, 100, 500, this.pageSizeMax];
    }

    pageSizeChange() {
        this.getApplications();
    }

    navigatePermit1(item, change) {
        if (change.value == 'edit') {
            let url: any = 'carrier/permit/application/edit/' + item.id;
            this.router.navigate([url]);
        } else {
            let permitStatus: any = environment.authWebApi.systemData.Configurations.find(config => config.Code == 'PermitStatus9').Value;
            permitStatus = parseInt(permitStatus);
            let dateValidTo: any = item.application.permit.date_valid_to;
            let add30date: any = null;
            let dec30date: any = null;
            let currentDate: any = new Date();
            if (dateValidTo != null) {
                let mod = new Date(dateValidTo);
                mod.setDate(mod.getDate() + 30);
                add30date = mod;
                let mod1 = new Date(dateValidTo);
                mod1.setDate(mod1.getDate() - 30 + 1);
                dec30date = mod1;
                if (currentDate.getTime() < dec30date.getTime()) {
                    this.toastService.error('You can only apply to renew a permit if it is within 30 days of expiry date.', 'Error');
                    return false;
                }
            }
            this.confirmDialogService.confirmThis(`Are you sure you want to renew ${item.permit_num} permit ?`, () => {
                this.copyPermit(item.id);
            }, () => {
                $('#selectControl option[value=\'\']').prop('selected', true);
                return false;
            })

        }
    }

    navigatePermit(item, change) {
        localStorage.setItem('oldAppId', item.application_id);
        switch (change) {
            case 'view' :
                localStorage.setItem('permitNum', item.number_of_permits);
                this.router.navigate(['/carrier/permit/application/view', item.application.id]);
                break;

            case 'edit' :
                localStorage.setItem('permitNum', item.number_of_permits);
                this.router.navigate(['/carrier/permit/application/edit', item.application_id]);
                break;

            case 'duplicate':
                if (new Date(item.date_valid_to) < new Date()) {
                    this.toastService.error(`Cannot duplicate an expired permit.`, `Duplicate Permit`);
                    setTimeout(() => {
                        this.getApplications();
                        this.getCarrier();
                        this.loadAccounts();
                        this.toaster.clear();
                        $('#selectControl option[value=\'\']').prop('selected', true);
                    }, 5000);
                    return;
                }
                if (item.is_valid && item.permit_type.can_get_duplicate) {
                    this.permitService.CheckPermitIssued(item.permit_num, item.permit_issue).subscribe(res => {
                        if (res) {
                            let username: any = this.user.LastName;
                            this.permitService.ManageDuplicate(item.id, username).subscribe((data: any) => {
                                let url: any = 'carrier/permit/application/duplicate/' + data.appliId;
                                this.router.navigate([url]);
                            });
                        } else {
                            //this.toaster.error("You cannot request a duplicate for this permit because there is an application in progress for this permit or it's already issued.", "The permit is not a valid permit.");
                            this.requestDeletePopup('Duplicate', 'There is a pending/ incomplete “Duplicate”  application for this Permit, please delete it before you start a new application', item);
                            //this.getApplications();
                            $('#selectControl option[value=\'\']').prop('selected', true);
                            return false;
                        }
                    })

                    // let url: any = "carrier/permit/application/duplicate/" + item.id;
                    // this.router.navigate([url]);
                } else {
                    this.toastService.error('You cannot request a duplicate for this type of permit.', 'The permit is not a valid permit.');
                    $('#selectControl option[value=\'\']').prop('selected', true);
                    this.getApplications();
                }
                break;
            case 'renew':
                this.message = 'Loading. Please wait...'
                this.gridload = true;
                let permitStatus: any = environment.authWebApi.systemData.Configurations.find(config => config.Code == 'PermitStatus9').Value;
                permitStatus = parseInt(permitStatus);
                let dateValidTo: any = item.date_valid_to;
                let add30date: any = null;
                let dec30date: any = null;
                let currentDate: any = new Date();
                //console.log('renew');
                if (dateValidTo != null) {
                    let mod = new Date(dateValidTo);
                    mod.setDate(mod.getDate() + 30);
                    add30date = mod;
                    let mod1 = new Date(dateValidTo);
                    mod1.setDate(mod1.getDate() - 30 + 1);
                    dec30date = mod1;
                    //console.log(currentDate);
                    //console.log(dec30date);
                    if (currentDate.getTime() < dec30date.getTime()) {
                        this.toastService.error('You can only apply to renew a permit if it is within 30 days of expiry date.', 'Error');
                        // this.getApplications();
                        // $("#selectControl option[value='']").prop('selected', true);
                        this.gridload = false;
                        return false;
                    }

                    if (currentDate.getTime() > add30date.getTime()) {
                        this.toastService.error('You must apply for a new permit as a renewal may not be done if the permit has expired more than 30 days ago', 'Error');
                        // this.getApplications();
                        // $("#selectControl option[value='']").prop('selected', true);
                        this.gridload = false;
                        return false;
                    }

                } else {
                    this.toastService.error('The expiry date of this permit could not be determined, please contact the system administrator for assistance.', 'Error');
                    this.gridload = false;
                    return false;
                }

                if (item.status_id > 90) {
                    this.toastService.error('This permit is no longer valid and cannot be renewed. Please apply for a new permit', 'Error');
                    this.gridload = false;
                    return false;
                }

                if (item.status_id < 70) {
                    this.toastService.error('This permit is not yet issued. Please withdraw the application and apply for a new permit.', 'Error');
                    this.gridload = false;
                    return false;
                }

                this.permitService.GetAllApplicationDetails(item.permit_num, item.renewal_num == null || item.renewal_num == undefined ? 0 : item.renewal_num).subscribe(res => {
                    this.gridload = false;
                    console.log('App Permit Renew', res);
                    if (res) {
                        this.confirmDialogService.confirmThis(`Are you sure you want to renew permit ${item.permit_num} ?`, () => {
                            this.copyPermit(item.id);
                        }, () => {
                            $('#selectControl option[value=\'\']').prop('selected', true);
                            return false;
                        })
                    } else {
                        $('#selectControl option[value=\'\']').prop('selected', true);
                        this.toastService.error('You cannot Renew this permit as it is already renewed', 'Renew Permit');
                        return false;
                    }
                }, error => {
                    this.toastService.error(`Error retrieving permit information. The server error response code is Error ${error.status} : ${error.statusText}`, `ERROR : Renew Permit`);
                    $('#selectControl option[value=\'\']').prop('selected', true);
                    return;
                });
                break;
            case 'timetable':
            case 'route':
                if (new Date(item.date_valid_to) < new Date()) {
                    this.toastService.error(`Cannot ammend route on expired permit.`, `Route Amendment`);
                    setTimeout(() => {
                        this.getApplications();
                        this.getCarrier();
                        this.loadAccounts();
                        this.toaster.clear();
                        $('#selectControl option[value=\'\']').prop('selected', true);
                    }, 5000);
                    return;
                }

                this.permitService.CheckPermitIssued(item.permit_num, item.permit_issue).subscribe(res => {
                    if (res) {
                        const is_route = (change.value == 'route') ? true : false;
                        this.utility.changeKey = 1;
                        this.processChangeRoute(item.id, this.user.LastName, is_route, item);
                    } else {
                        //this.toaster.error("You cannot amend route for this permit because there is an application in progress this permit or it's already issued", "Route Amendment");
                        this.requestDeletePopup('Route Amendment', 'There is a pending/ incomplete “Route Amendment”  application for this Permit, please delete it before you start a new application', item);
                        $('#selectControl option[value=\'\']').prop('selected', true);
                        return false;
                    }
                });
                break;
            case 'compliance':
                const compliance = {
                    carrierId: item.carrier.id,
                    carrierName: item.carrier_name,
                    carrierNum: item.carrier_code,
                    carrierTradingName: item.trading_name,
                    carrierRegNum: item.company_registration,
                    permitKey: item.id,
                    permitNum: item.permit_num,
                    permitType: item.permit_type.description,
                    vehicle_reg_num: item.vehicle_reg_num,
                    freight_passenger_ind: item.permit_type.freight_passenger_ind,
                    url: `carrier/permit/application/mypermits/${item.carrier.id}`
                };
                // this.session.setCompliance(compliance);
                this.router.navigate(['/carrier/compliance/application'], {
                    queryParams: {
                        id: item.carrier_id,
                        appID: item.application_id,
                        compID: item.id,
                        typeId: item.permit_type_id
                    }
                });
                // this.router.navigate([this.utility.cplURL]);
                break;
            case 'vehicle':
                this.permitService.CheckPermitIssued(item.permit_num, item.permit_issue).subscribe(res => {
                    if (res) {
                        if (new Date(item.date_valid_to) < new Date()) {
                            this.toastService.error(`Cannot replace vehicle on expired permit.`, `Vehicle Replacement`);
                            setTimeout(() => {
                                this.getApplications();
                                this.getCarrier();
                                this.loadAccounts();
                                this.toaster.clear();
                                $('#selectControl option[value=\'\']').prop('selected', true);
                            }, 5000);
                            return;
                        }
                        if (item.vehicle_reg_num.length > 0) {
                            const is_vehicle = (change.value == 'vehicle') ? true : false;
                            this.utility.changeKey = 3;
                            this.processChangeVehicle(item.id, this.user.LastName, is_vehicle);
                        } else {
                            this.toastService.error(`Please make sure that there is a vehicle to be replaced.`, `Vehicle Replacement`);
                            setTimeout(() => {
                                this.getApplications();
                                this.getCarrier();
                                this.loadAccounts();
                                this.toaster.clear();
                                $('#selectControl option[value=\'\']').prop('selected', true);
                            }, 5000);
                        }
                    } else {
                        //this.toaster.error("You cannot Replace Vehicle for this permit because there is an application in progress this permit or it's already issued","Vehicle Replacement");
                        this.requestDeletePopup('Vehicle Replacement', 'There is a pending/incomplete “Replacement”  application for this Permit, please delete it before you start a new application', item);

                        $('#selectControl option[value=\'\']').prop('selected', true);
                        return false;
                    }
                });
                break;
            case 'permitCorrection':
                if (new Date(item.date_valid_to) < new Date()) {
                    this.toastService.error(`Cannot correct an expired permit.`, `Permit Correction`);
                    setTimeout(() => {
                        this.getApplications();
                        this.getCarrier();
                        this.loadAccounts();
                        this.toaster.clear();
                        $('#selectControl option[value=\'\']').prop('selected', true);
                    }, 5000);
                    return;
                }

                let printedIssuedStatus: any = environment.authWebApi.systemData.Configurations.find(config => config.Code == 'PermitStatus8').Value;
                if (item.status_id != printedIssuedStatus) {
                    this.toastService.error(`This permit is not yet issued. Please withdraw the application and apply for a new permit.`, 'Error');
                    return false;
                }
                this.manageCorrectPermit(item.id, this.user.LastName);

                ///Old Rule for the correction of permits
                // this.permitService.CheckPermitIssued(item.permit_num, item.permit_issue).subscribe(res => {
                //     if (res) {
                //         this.manageCorrectPermit(item.id, this.user.LastName);
                //     } else {
                //         //this.toaster.error("You cannot do Error Correction for this permit because there is an application in progress for this permit or it's already issued","Error Correction");
                //         this.requestDeletePopup('Error Correction', 'There is a pending/ incomplete “Error Correction”  application for this Permit, please delete it before you start a new application', item);
                //         $('#selectControl option[value=\'\']').prop('selected', true);
                //         return false;
                //     }
                // });
                /// Old Rule
                break;


            case 'myNum' :
                return this.router.navigate(['under-construction']);

            case 'confirm':
                if (item.status_id < this.permitStatus13) {
                    this.toastService.error('Permit must have been approved before you can confirm the details', 'Error');
                    return;
                }
                if (item.status_id > this.permitStatus7) {
                    this.toastService.error('Permit has already been processed and you cannot change it', 'Error');
                    return;
                }
                this.router.navigate(['/carrier/permit/application/view/' + item.application_id + '/' + 2]);
                break;

            case 'cancelApp':
                this.cancelApplication(item.id);
                break;
            case 'viewPermit':
                this.viewPrintedPermit(item.id);
                break;

            case 'delete':
                this.deleteApplication(item.id);
                break;
        }
    }

    requestDeletePopup(header, message, item) {
        let permDescription = item.permit_num + '/' + (item.permit_issue + 1);
        // this.showModal.showYesNo(header, message, `You're about to delete pending permit: ` + permDescription, 'Yes', 'No')
        //     .subscribe((isConfirmed) => {
        //       if (isConfirmed) {
        //         this.pageload = true;
        //        this.permitService.deletePermitByPermitNumAndIssueNum(item.permit_num, item.permit_issue+1).subscribe(deleted =>{
        //         this.pageload = true;
        //         if(deleted)
        //          {
        //             this.toaster.success('Deleted Permit "' + permDescription + '", you can proceed' );
        //          }
        //          else{
        //           this.toaster.error('Cannot delete Permit "' + permDescription + '"' );
        //          }
        //        });
        //       } else {

        //         return false;
        //       }
        //     });
        this.confirmDialogService.confirmThis(message + ' You\'re about to delete pending permit: ' + permDescription, () => {

            this.pageload = true;
            this.permitService.deletePermitByPermitNumAndIssueNum(item.permit_num, item.permit_issue + 1).subscribe(deleted => {
                this.pageload = true;
                if (deleted) {
                    this.toastService.success('Deleted Permit "' + permDescription + '", you can proceed', 'success');
                } else {
                    this.toastService.error('Cannot delete Permit "' + permDescription + '"', 'Error');
                }
            });

        }, () => {
            return false;
        })

    }

    viewPrintedPermit(id) {
        let obj = {
            pId: id,
            ReportName: 'Permit'

        }
        //console.log(obj);

        this.gridload = true;
        this.isLoadingImg = true;
        this.permitService.PrintingPermitView(obj).subscribe(data => {
            let objectURL = URL.createObjectURL(data);
            //console.log(objectURL);
            $('#exampleModalLong').modal('show');
            this.pdfSrc = objectURL;
            this.gridload = false;
            this.isLoadingImg = false;

        })
    }

    isCanBeAmended = (item: any) => {
        const data = item;
        if (!data.permits[0].is_valid) {
            return false;
        } else {
            return (data.permit_type.can_amend_route || data.permit_type.can_amend_timetable || data.permit_type.can_replace_vehicle);
        }
    }
    isComplianceReturned = (item: any) => {
        const data = item.application;
        //console.log(data.permit);
        return (data.permit.cplce_return_id > 0);

    }
    processChangeRoute = (perm_id, username, is_route, application) => {
        this.message = 'Processing your request, please wait...!';
        this.gridload = true;
        console.log("Application", application);
        localStorage.setItem('timetable', application.permit_type.timetable_reqd);
        this.permitService.changeRoute(perm_id, username, is_route).subscribe((resp: any) => {
            this.gridload = false;
            let url: any = `carrier/permit/application/change/${resp.appliId}/true`;
            this.router.navigate([url]);

        }, error => {
            this.gridload = false;
            this.toastService.error('Your request could not be processed succesfully.Please contact the system admin if the problem persists.', 'Error');

        });
    }

    processChangeVehicle(permit_id, username, isVehicle) {
        this.message = 'Processing your request, please wait...!';
        this.gridload = true;
        this.permitService.changeVehicle(permit_id, username, isVehicle).subscribe((resp: any) => {
            this.gridload = false;
            let url: any = `carrier/permit/application/change/${resp.appliId}/vehicle`;
            this.router.navigate([url]);

        }, error => {
            this.gridload = false;
            this.toastService.error('Your request could not be processed succesfully.Please contact the system admin if the problem persists.', 'Error');

        });
    }

    manageCorrectPermit(id, user) {
        this.message = 'Processing your request, please wait...!';
        this.gridload = true;
        let correctDays1: any = environment.authWebApi.systemData.Configurations.find(config => config.Code == 'CorrectDays1').Value;

        this.permitService.isPermitCorrectionApplicable(id).subscribe(data => {
            if (data === true) {
                this.processPermitCorrection(id, user);
                // let url: any = `carrier/permit/application/change/${appid}/correction`;//remove when permit type code is avail
                // this.router.navigate([url]);
            } else {
                // let url: any = `carrier/permit/application/change/${appid}/correction`;
                // this.router.navigate([url]);
                this.toastService.error('You cannot request a change after ' + correctDays1 + ' day(s)', 'Error');
                $('#selectControl option[value=\'\']').prop('selected', true);
            }
            this.gridload = false;

        }, error => {
            this.gridload = false;
            this.toastService.error('Your request could not be processed succesfully.Please contact the system admin if the problem persists.', 'Error');
            $('#selectControl option[value=\'\']').prop('selected', true);
        })

    }

    processPermitCorrection(perm_id, username) {
        this.permitService.corrections(perm_id, username).subscribe((resp: any) => {
            let url: any = `carrier/permit/application/change/${resp.appliId}/correction`;
            this.router.navigate([url]);

        }, error => {
            this.toastService.error('Your request could not be processed succesfully.Please contact the system admin if the problem persists.', 'Error');

        });
    }

    cancelApplication(id) {

        this.confirmDialogService.confirmThis('Are you sure that you want to cancel your application. If your application fee has been paid you cannot get it refunded. If your permit fee has been paid, you must contact us to apply for a refund.', () => {

            this.confirmDialogService.confirmThis('You are about to cancel your application. Press Yes to continue and cancel the application.You can find it on My Applications screen', () => {

                this.message = 'Processing your request, please wait...!';
                this.gridload = true;

                this.permitService.UpdatePermitStatus(id).subscribe(data => {
                    if (data === true) {
                        this.toastService.success('The application was cancelled successfully', 'success');
                        this.getApplications();

                    } else {

                        // this.toaster.error('You cannot request a change after ' + correctDays1 + ' day(s)');
                    }
                    this.gridload = false;

                }, error => {
                    this.gridload = false;
                    this.toastService.error('Your request could not be processed succesfully.Please contact the system admin if the problem persists.', 'Error');

                })


            }, () => {
                return false;
            })

        }, () => {
            return false;
        })
    }

    deleteApplication(applicationData) {


        this.confirmDialogService.confirmThis('Are you sure you want to delete this permit application?.', () => {

            this.message = 'Processing your request, please wait...!';
            this.gridload = true;

            this.applicationService.deleteApplication(applicationData.id).subscribe(data => {
                if (data === true) {
                    this.toastService.success('The Permit Application was deleted successfully', 'success');
                    this.getApplications();
                    console.log('app', applicationData.id);

                } else {

                    // this.toaster.error('You cannot request a change after ' + correctDays1 + ' day(s)');
                }
                this.gridload = false;

            }, error => {
                this.gridload = false;
                this.toastService.error('Your request could not be processed succesfully.Please contact the system admin if the problem persists.', 'error');

            })

        }, () => {
            return false;
        })
    }

    navigateToApplyPermit() {
        this.router.navigateByUrl('/carrier/permit/application/new/' + this.dataCntrl.carrierID);
        console.log('whatsin', this.dataCntrl.carrierID);
    }

    CheckedPermit(event, item, index) {
        this.selectedIndex = event.target.checked ? index : undefined;
        if (event.target.checked) {
            this.selectedPermitData = item;
        } else {
            this.selectedPermitData = null;
        }
    }

    searchPermit(permitNumber,permitStatus, regnumber) {

        let searchObj =
            {
                'PermitNum': permitNumber,
                'PermitStatus': permitStatus,
                'Start': '',
                'End': '',
                'RegistrationNumber': regnumber,
                'RouteId': 0,
                'PermitId': 0,
                'PageNum': this.pageNumber,
                'PageSize': this.pageSize,
                'CarrierCode': '',
                'CarrierId': this.dataCntrl.carrierID
            }

            console.log("Search Obj", searchObj);
        console.log("Permit Number", this.permitNumber);
        this.permitService.searchPermits(searchObj).subscribe((res: any) => {
            if(res){
                this.gridload = false;
                this.Count = res.Count;
                this.isEmpty = false;
                this.dataCntrl.permits = res.Items;
                console.log('Permit Data', this.dataCntrl.permits);
                this.loadCompleted = true;
            }else{
                this.isEmpty = true;
                this.gridload = false;
                this.Count = 0;
                this.dataCntrl.permits = [];
            }


        });
    }

    filterPermits() {

        this.filter.getData().pipe(take(1)).subscribe((data) => {

            console.log('Search Data', data)
            this.regNumber = data.regNumber;
            this.permitNumber = data.permitNumber;
            this.permitStatus = []
            if(data.statusMultiSelect)
            {
                for (let i = 0; i < data.statusMultiSelect.length; i++) {
                    this.permitStatus.push(data.statusMultiSelect[i].id);
                }
            }

            if (!this.isSearchable()) {
                this.toastService.error(
                    'Please provide at least one filter value.',
                    'Permit Search'
                );
                return;
            }
            this.searchPermit(data.permitNumber, this.permitStatus, data.regNumber);
        });
    }
y: number = 0
    resetData(){
        console.log("Fired Reset Data", this.y++)
        this.permitNumber = ''
        this.permitStatus =[]
        this.regNumber = ''

        this.searchPermit(this.permitNumber, this.permitStatus, this.regNumber);
    }

    changeStatus(id :any , item : any){
        this.gridload = true;
        console.log("changeStatus", item)

        if(item.status_description != "Approved"){
            this.toastService.error('Can only cancel approved permits', 'success');
            this.gridload = false;
        }
        else{
        this.permitService.UpdatePermitStatus(id).subscribe(res=>{
            this.getApplications();
            this.toastService.success('Permit cancelled successfully', 'success');
            this.gridload = false;
        });
    }



    }
}
